module.exports = {
	additionalParams: [
		'aconp',
		'ad_rule',
		'ad_type',
		'addtl_consent',
		'adtest',
		'afvsz',
		'allcues',
		'an',
		'ciu_szs',
		'cmsid',
		'dth',
		'excl_cat',
		'gdpr',
		'gdpr_consent',
		'givn',
		'hl',
		'iabexcl',
		'idtype',
		'ipd',
		'ipe',
		'is_lat',
		'iu',
		'lip',
		'ltd',
		'min_ad_duration',
		'mridx',
		'msid',
		'nofb',
		'omid_p',
		'paln',
		'plcmt',
		'pmad',
		'pmnd',
		'pmxd',
		'pod',
		'pp',
		'ppt',
		'ppid',
		'ppos',
		'ppsj',
		'ptpl',
		'ptpln',
		'pubf',
		'pvid',
		'pvid_s',
		'pvtf',
		'rdid',
		'rdp',
		'schain',
		'scor',
		'sdk_apis',
		'sdmax',
		'sid',
		'ssss',
		'trt',
		'url',
		'vconp',
		'vid',
		'vid_d',
		'vpa',
		'vpi',
		'vpmute',
		'vpos',
		'wta'
	]
};
